/**
 * localStorage 封装
 * --------------------------------------------------------------
 * 所有键自动加前缀 love-xjj.，避免与第三方冲突。
 * JSON 解析失败、SSR 等异常情况下安全回退到 fallback 值。
 */

const PREFIX = 'love-xjj.'

export const storage = {
  /** @template T @param {string} key @param {T} [fallback] @returns {T} */
  get(key, fallback = null) {
    try {
      const raw = localStorage.getItem(PREFIX + key)
      return raw == null ? fallback : JSON.parse(raw)
    } catch {
      return fallback
    }
  },

  /** @param {string} key @param {*} value */
  set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value))
    } catch {
      // 配额满 / 隐私模式 等异常静默
    }
  },

  /** @param {string} key */
  remove(key) {
    try {
      localStorage.removeItem(PREFIX + key)
    } catch {}
  },

  /** 清空所有 love-xjj.* 数据（调试用） */
  clearAll() {
    try {
      Object.keys(localStorage)
        .filter(k => k.startsWith(PREFIX))
        .forEach(k => localStorage.removeItem(k))
    } catch {}
  },
}
